export const fileTypes = {
  pdf: 'pdf',
  jpg: 'jpg',
  jpeg: 'jpeg',
  png: 'png',
  html: 'html',
};

export const MIN_FILE_SIZE = 1;
export const MIN_FILE_SIZE_BYTES = 1;
export const MAX_FILE_SIZE = 10;
export const MAX_FILE_SIZE_BYTES = 10000000;
export const MAX_ATTACHMENT_LIMIT = 6;

export const MAIN_FLOWS = {
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  pdf: 'application/pdf',
  png: 'image/png',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  doc: 'application/msword',
};

export const PROFILE_PIC_FLOWS = {
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
};
